import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { GET_CAPTCHA_API } from 'modules/authentication/api/constants'

interface UseCaptchaTokenParams {
  onError?: () => void
}

export default function useCaptchaToken({ onError }: UseCaptchaTokenParams = {}) {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, { openKey: string }>(
    {
      method: RequestMethodsEnum.get,
      badRequestHandler: onError ?? (() => {}),
      notFoundResponseHandler: onError ?? (() => {}),
    },
  )

  const { isValidating: isLoading, data } = useSWR(() => {
    return GET_CAPTCHA_API
  }, fetcher)

  return { data, isLoading }
}
